import React, { useEffect, useRef, useState } from "react";
import {useStoreGlobal} from '../../../stores/Global'
import {useShallow} from 'zustand/react/shallow'
export default function SelectOrderAscDesc(props) {
  const _updateFiltros= useStoreGlobal(useShallow((state) => state._updateFiltros));
  const orderAscdesc = useRef(null);
  const [isActive, setIsActive] = useState(true);
  const [selectedOrder, setSelectedOrder] = useState("");
  
  let var_DescAsc = "Desc";
  let var_ingles = "es";
  if (window.location.href.indexOf("en.") > -1) {
    var_ingles = "en";
  }
  const handleClickDescAsc = (event) => {
    setIsActive(!isActive);
    let order = event.target.innerText;

    let varAux= isActive ? "Ascendente" : "Descendente";
    

    if (var_ingles === "en") {
      varAux = isActive? "Ascending" : "Descending";
    }
    else {
      varAux = isActive ? "Ascendente" : "Descendente";
    } 
    if (var_ingles ==="es"){
      order =(varAux==="Descendente")?"Desc":"Asc";
    }
    else{
      order =(varAux==="Descending")?"Desc":"Asc";
    }

    // if (var_ingles ==="es"){
    //   order =(varAux==="Descendente")?"Asc":"Desc";
    // }
    // else{
    //   order =(varAux==="Descending")?"Asc":"Desc";
    // }
    setSelectedOrder(order);
    _updateFiltros({ordenamiento:order});
    $("#search").trigger("click");
  };
  const handleSelecAscDesc = (event) => {
    const Order = event.target.value;
    setSelectedOrder(Order);
    
}
  useEffect(() => {
    if (orderAscdesc !== null) {
      let valor =orderAscdesc.current.innerText;
        valor = (valor === "")? "Desc" : selectedOrder;
    _updateFiltros({ordenamiento:valor});
    }
  }, []);

  return (
    <div
      className="col-md-1 col-xs-1"
      id="orderAscdesc"
      style={{ marginTop: "9px" }}
    >
      <div
        className={isActive ? "inegi-desc" : "inegi-asc"}
        style={{ cursor: "pointer" }}
        id="ordenAsDs"
        ref={orderAscdesc}
       
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        value={isActive ? var_DescAsc : "Asc"}
        title={isActive
            ? var_ingles === "es"
              ? "Descendente"
              : "Descending"
            : var_ingles === "es"
            ? "Ascendente"
            : "Ascending"
            } 
        onClick={handleClickDescAsc}
        onChange={handleSelecAscDesc}
        // data-tooltip-content={
        //   isActive
        //     ? var_ingles === "es"
        //       ? "Descendente"
        //       : "Descending"
        //     : var_ingles === "es"
        //     ? "Ascendente"
        //     : "Ascending"
        // }
        // data-tooltip-id="ordenAsDs"
        // value={isActive ? var_DescAsc : "Asc"}
      >
        {/* <Tooltip id="ordenAsDs" place="top" /> */}
      </div>
    </div>
  );
}
